import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { useSelector } from 'react-redux';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import RenderMilestones from '../components/RenderMileStones';
import { assignAgentsToTicketMilestone } from '../../../actions/service_request';
import { actualValueForDropdown } from '../../../utils/common';
import Users from '../../../components/Inputs/Users';
import { bulkAssignAgentsOfServiceRequest } from '../../../actions/service_request';

const formName = 'assign_tech_support';

export default function AssignTechSupport({ ticketId, milestones, isBulk = false, org_id, agents }) {
    const defaultValues = {};
    const dispatch = useDispatch();
    const { formButtonLoading } = useSelector((state) => state.loading);
    const [selectedMilestones, setSelectedMilestones] = useState([]);

    const submit = (formValues) => {
        if (isBulk) {
            const payload = { agents: [] };
            milestones.forEach((milestone) => {
                payload.agents.push({
                    agent_id: actualValueForDropdown(formValues.user),
                    role: "REMOTE_SUPPORT",
                    milestone_id: milestone.id,
                    removePrevAgent: true
                });
            });

            dispatch(bulkAssignAgentsOfServiceRequest({ payload, formName }));
        } else {
            const payload = {
                agent: {
                    agent_id: actualValueForDropdown(formValues.user),
                    role: "REMOTE_SUPPORT",
                    milestone_id: selectedMilestones,
                    removePrevAgent: true
                },
            };
            dispatch(assignAgentsToTicketMilestone({ ticketId: ticketId, milestoneId: selectedMilestones, payload, formName }));
        }
    };

    const methods = useForm({ defaultValues, mode: 'all' });

    return (
        <div>
            {!isBulk && <div className='px-8 py-4'>
                <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={agents} />
            </div>}
            <Form
                methods={methods}
                onSubmit={submit}
                formName={formName}
                buttonPostion={'justify-end'}
                submitButtonText={'Submit'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
            >
                <div className='px-4 py-2'>
                    <Users name='user' label='Select Tech Support' org_id={org_id} is_possible_remote_support={true} />
                </div>
            </Form>
        </div>
    );
};